// extracted by css-extract-rspack-plugin
export default {"container":"_ccfc3da5","paragraph":"_dec3c50c"};